// A singleton controller for a persistent HTMLAudioElement.
// The element is created once and reused; callers can attach it to any container.

let audioElement = null;
let attachedContainer = null;

function ensureAudio() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return null;
    if (!audioElement) {
        const a = document.createElement('audio');
        a.preload = 'auto';
        a.controls = true;
        a.style.width = '100%';
        a.className = 'rounded-lg';
        audioElement = a;
        try {
            audioElement.addEventListener('play', () => console.log('[globalAudio] play'));
            audioElement.addEventListener('pause', () => console.log('[globalAudio] pause'));
            audioElement.addEventListener('loadeddata', () => console.log('[globalAudio] loadeddata'));
            audioElement.addEventListener('canplay', () => console.log('[globalAudio] canplay'));
            audioElement.addEventListener('timeupdate', () => {});
        } catch (_) {}
    }
    return audioElement;
}

function get() {
    return ensureAudio();
}

function attach(container) {
    const el = ensureAudio();
    if (!el || !container) return;
    if (attachedContainer !== container) {
        try {
            if (el.parentElement && el.parentElement !== container) {
                el.parentElement.removeChild(el);
            }
        } catch (_) {}
        try { container.appendChild(el); attachedContainer = container; } catch (_) {}
    } else if (!container.contains(el)) {
        try { container.appendChild(el); } catch (_) {}
    }
}

function setSource(src) {
    const el = ensureAudio();
    if (!el || !src) return;
    if (el.src !== src) {
        console.log('[globalAudio] setSource', { from: el.src, to: src });
        el.src = src;
    }
}

function clear() {
    const el = ensureAudio();
    if (!el) return;
    try { el.pause(); } catch (_) {}
    try { el.removeAttribute('src'); el.load?.(); } catch (_) {}
}

function captureState() {
    const el = ensureAudio();
    if (!el) return { wasPlaying: false, currentTime: 0 };
    return { wasPlaying: !el.paused, currentTime: el.currentTime || 0 };
}

function restoreState(state) {
    const el = ensureAudio();
    if (!el || !state) return;
    const apply = () => {
        try { if (Number.isFinite(state.currentTime)) el.currentTime = state.currentTime; } catch (_) {}
        try {
            if (state.wasPlaying) {
                const p = el.play();
                if (p && typeof p.catch === 'function') p.catch(() => {});
            }
        } catch (_) {}
    };
    if ((el.readyState || 0) >= 2) apply();
    else {
        const once = () => { el.removeEventListener('loadeddata', once); el.removeEventListener('canplay', once); apply(); };
        el.addEventListener('loadeddata', once);
        el.addEventListener('canplay', once);
    }
}

export default { get, attach, setSource, clear, captureState, restoreState };


